export default "__VITE_ASSET__CYzr5b7N__"